module.exports = __webpack_public_path__ + "static/media/violet.19bd72f8.png";